import {useEffect, useRef, useState} from 'react';
import {useKeenSlider} from 'keen-slider/react';
import {digitsEnToFa} from 'persian-tools2';

export default function Wheel(props) {
  const perspective = props.perspective || 'center';
  const wheelSize = 20;
  const slides = props.length;
  const slideDegree = 360 / wheelSize;
  const slidesPerView = props.loop ? 9 : 1;
  const [sliderState, setSliderState] = useState(null);
  const size = useRef(0);
  const [options, setOptions] = useState({
    slides: {
      number: slides,
      origin: props.loop ? 'center' : 'auto',
      perView: slidesPerView,
    },

    vertical: true,

    initial: props.initIdx || 0,
    loop: props.loop,
    dragSpeed: (val) => {
      const height = size.current;
      return (
        val *
        (height /
          ((height / 2) * Math.tan(slideDegree * (Math.PI / 180))) /
          slidesPerView)
      );
    },
    created: (s) => {
      size.current = s.size;
    },
    updated: (s) => {
      size.current = s.size;
    },
    detailsChanged: (s) => {
      setSliderState(s.track.details);
    },
    rubberband: !props.loop,
    mode: 'free-snap',
  });

  const [sliderRef, slider] = useKeenSlider(options);

  const [radius, setRadius] = useState(0);

  useEffect(() => {
    setOptions((prev) => ({
      ...prev,
      slides: {
        number: props.length,
        origin: props.loop ? 'center' : 'auto',
        perView: slidesPerView,
      },
    }));
  }, [props?.length]);

  useEffect(() => {
    if (slider.current) setRadius(slider.current.size / 2);
  }, [slider]);

  function slideValues() {
    if (!sliderState) return [];
    const offset = props.loop ? 1 / 2 - 1 / slidesPerView / 2 : 0;

    const values = [];
    for (let i = 0; i < slides; i++) {
      const distance = sliderState
        ? (sliderState.slides[i]?.distance - offset) * slidesPerView
        : 0;
      const rotate =
        Math.abs(distance) > wheelSize / 2
          ? 180
          : distance * (360 / wheelSize) * -1;
      const style = {
        transform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
        WebkitTransform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
      };
      const value = props.year ? props.items[i]?.value : props.items[i];
      values.push({style, value});
    }
    props.setSelected(sliderState);
    return values;
  }

  return (
    <div
      className={'wheel keen-slider wheel--perspective-' + perspective}
      ref={sliderRef}>
      <div
        className='wheel__shadow-top'
        style={{
          transform: `translateZ(${radius}px)`,
          WebkitTransform: `translateZ(${radius}px)`,
        }}
      />
      <div className='wheel__inner'>
        <div className='wheel__slides' style={{width: props.width + 'px'}}>
          {slideValues().map(({style, value}, idx) => (
            <div className='wheel__slide' style={style} key={idx}>
              <div
                style={{
                  letterSpacing: props.addletterSpacing && '1.5px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}>
                {digitsEnToFa(value)}
              </div>
            </div>
          ))}
        </div>
        {props.label && (
          <div
            className='wheel__label'
            style={{
              transform: `translateZ(${radius}px)`,
              WebkitTransform: `translateZ(${radius}px)`,
            }}>
            {props.label}
          </div>
        )}
      </div>
      <div
        className='wheel__shadow-bottom'
        style={{
          transform: `translateZ(${radius}px)`,
          WebkitTransform: `translateZ(${radius}px)`,
        }}
      />
    </div>
  );
}
